import { render, staticRenderFns } from "./annual-report-cn.vue?vue&type=template&id=273e982c&"
import script from "./annual-report-cn.vue?vue&type=script&lang=js&"
export * from "./annual-report-cn.vue?vue&type=script&lang=js&"
import style0 from "./annual-report-cn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports